export default "__VITE_ASSET__BdHgYqI7__"